export default __webpack_public_path__ + "static/media/07-ideation-principles.370d6590.svg";